export default __webpack_public_path__ + "static/media/news1.168b71bc.jpg";